export class ResponseCodes {
  public static readonly FJ5CAT_1002: string = 'FJ5CAT_1002';

  // #TODO object should match specific service scenario
  public static readonly VALIDATION_EXCHANGE_STATUSES = {
    SUCCESS: 'SUCCESS',
    PRINCIPAL_MISMATCH: 'PRINCIPAL_MISMATCH',
    INTEREST_MISMATCH: 'INTEREST_MISMATCH',
    PRINCIPAL_INTEREST_MISMATCH: 'PRINCIPAL_INTEREST_MISMATCH',
    ERROR: 'ERROR',
  } as const;

  public static readonly EXCHANGE_CALCULATE_FEE_STATUSES = {
    ERROR_CODES: {
      FJ5CAT_1005: 'FJ5CAT_1005',
    },
  } as const;
}
